import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  private adminDetails = new BehaviorSubject<any>(null);
  constructor(public http: HttpClient, private httpService: HttpService) {}

  public getTabConfigItems() {
    const url = 'user/getuserconfigs?tabName=admin';
    return this.httpService.get(url);
  }

  public getAdminConfig(): Observable<any> {
    const url = 'user/getuserconfigs?tabName=admin';
    return this.httpService.get(url);
  }

  getAdminDetails(): Observable<any> {
    return this.adminDetails.asObservable();
  }

  updateConfig(newData: any): void {
    this.adminDetails.next(newData);
  }
}
